export * from "./fetch";
import { useAPI } from "../../utils/use-api";
import { Endpoint } from "../common/endpoints";
import { useInfiniteAPI, } from "../../utils/use-infinite-api";
import { useMutation } from "../../utils/use-mutation";
import { userCreate, userUpdateSelf, userUpdate, userEnable, userDisable, userCreateOnfidoToken, userVerifySelf, } from "./fetch";
export const useUserCreate = (params) => {
    return useMutation(userCreate, params);
};
export const useUserList = (queryParams, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.UserList,
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useInfiniteUserList = (queryParams, shouldMakeRequest, swrOptions) => {
    return useInfiniteAPI({
        endpoint: Endpoint.UserList,
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useUserShowSelf = (shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.UserShowSelf,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useUserSelf = (userId, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.UserSelf,
        endpointParams: { userId },
        shouldMakeRequest,
        swrOptions,
    });
};
export const useUserSecurityQuestionsSelf = (shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.UserSecurityQuestionsSelf,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useUserSecurityQuestions = (userId, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.UserSecurityQuestions,
        endpointParams: { userId },
        shouldMakeRequest,
        swrOptions,
    });
};
export const useUserUpdateSelf = (params) => {
    return useMutation(userUpdateSelf, params);
};
export const useUserUpdate = (userId, params) => {
    return useMutation((body, queryParams, headers) => {
        return userUpdate(userId, body, queryParams, headers);
    }, params);
};
export const useUserEnable = (userId, params) => {
    return useMutation((body, queryParams, headers) => {
        return userEnable(userId, body, queryParams, headers);
    }, params);
};
export const useUserDisable = (userId, params) => {
    return useMutation((body, queryParams, headers) => {
        return userDisable(userId, body, queryParams, headers);
    }, params);
};
export const useUserCreateOnfidoToken = (params) => {
    return useMutation(userCreateOnfidoToken, params);
};
export const useUserVerifySelf = (params) => {
    return useMutation(userVerifySelf, params);
};
export const useUserEnforcePasswordReset = (shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.UserEnforcePasswordReset,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useUserListOrganisations = (userId, queryParams, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.UserListOrganisations,
        endpointParams: { userId },
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useUserListOrganisationsSelf = (queryParams, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.UserListOrganisationsSelf,
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
